import withAemIntegration from "../../../withAemIntegration";
import {
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import loadable from "@loadable/component";
import ComponentWrapper from "../../component-wrapper";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/ConditionalParamsModule")
);

const ComponentEditConfig = {
  emptyLabel: "Personalized Container",
  isEmpty: (props) => !props?.children?.length,
};

export class ConditionalParamsModule extends ResponsiveGrid {
  render() {
    const { editorMode = false } = window;
    const containerType = this.props.authorizationType;

    const showComponents = true;

    if (editorMode)
      return (
        <div>
          <h2>{containerType} Container</h2>
          <ComponentWrapper>{super.childComponents}</ComponentWrapper>
          {super.placeholderComponent}
        </div>
      );

    if (showComponents)
      return (
        <Component {...this.props}>
          <ComponentWrapper>{super.childComponents}</ComponentWrapper>
        </Component>
      );

    return null;
  }
}
const ContainerComponent = withComponentMappingContext(ConditionalParamsModule)
ContainerComponent.displayName = "ContainerComponent"

export default withAemIntegration("lexus/components/drivers/container")(
  ContainerComponent,
  ComponentEditConfig
);
